import React from 'react';

export default function Home() {
  return (
    <div className='text-gray-700 text-lg'>
      👈 사이드바에서 연습 항목을 선택해보세요!
    </div>
  );
}
